import React from 'react'
import { Box, Typography } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"


export default function conditionNameColumn() {

	const iconMap = {
		"Lower": "less-than",
		"Higher": "greater-than",
		"Different": "not-equal"
	}

	const colorMap = {
		"Lower": "error.main",
		"Higher": "success.main",
		"Different": "warning.main"
	}

	return {
		name: 'conditionName',
		label: 'Condition',
		options: {
			filter: false,
			customBodyRowRenderLite:
				(value, { comparatorName, comparatorValue }) => <Box sx={{
					alignItems: "center",
					justifyContent: "center",
					display: "flex",
					flexDirection: "column"
				}}>
					<Typography sx={{ fontWeight: "bold" }}>{value}</Typography>
					<Box sx={{ alignItems: "center", justifyContent: "center", display: "flex" }}>
						<IconSeeker
							icon={iconMap[comparatorName]}
							sx={{
								mx: .7,
								color: colorMap[comparatorName],
								fontSize: 14
							}}
						/>
						<Typography sx={{ fontWeight: "bold" }}>{`${comparatorValue} `}</Typography>
						<IconSeeker icon="star-sharp" sx={{ mx: .7, color: "warning.main", fontSize: 13 }}/>
					</Box>
				</Box>
		}
	}
}